// extracted by mini-css-extract-plugin
module.exports = {"summary":"_3tsHj1wnERccfek8tWsg2F","row":"_3babNA8Qjx-YO5prb82v_O","rightLand":"_2XJGyxUg_7-6IH8wYkYGp"};